import { MobilityPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function Mobility() {
  return (
    <MobilityPageProvider>
      <IndustryPageLayout />
    </MobilityPageProvider>
  );
}
